import { z } from "zod";

export const tabularGeneralSettingsSchema = z.object({
  showGrandTotal: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  groupSummaryPlace: z
    .preprocess((val) => val ?? "Footer", z.union([z.literal("Footer"), z.literal("Inline")]))
    .catch("Footer"),
  subtotalLabelPosition: z
    .preprocess(
      (val) => val ?? "None",
      z.union([z.literal("None"), z.literal("Group"), z.literal("Leading"), z.literal("Trailing")])
    )
    .catch("None"),
  subtotalLabelFormatPrefix: z.preprocess((val) => val ?? "", z.string()).catch(""),
  subtotalLabelFormatSuffix: z.preprocess((val) => val ?? "", z.string()).catch(""),
  hideBlankRows: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  hideBlankColumns: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  hideZeroRows: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  hideZeroColumns: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  showGroupedColumns: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  showNonZeroBalanceAccounts: z.preprocess((val) => val ?? false, z.boolean()).catch(false),
  freezedColumns: z.preprocess((val) => val ?? [], z.array(z.string())).catch([]),
});

export const tileSettingsSchema = z.object({
  compareWithPreviousPeriod: z.boolean().default(false),
  showGrowth: z.boolean().default(false),
  periodType: z.enum(["LastMonth", "LastQuarter", "LastYear"]).default("LastMonth"),
});
